import { Strings } from '../assets/res/en'
export default function telephonesDataColumn(phoneTypes) {
    let mapped = phoneTypes.map(item => ({ [item.val]: item.text }))
    let phoneTypeItems = Object.assign({}, ...mapped)
    const teleCols = [
        { title: Strings.PHONE_NUMBER, field: 'phoneNumber', validate: rowData => (rowData.phoneNumber && rowData.phoneNumber.match(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/i)) ? true : false  },
        { title: Strings.PHONE_TYPE, field: 'idPhoneType', lookup: phoneTypeItems, validate:rowData=> rowData.idPhoneType ? true : false },
        { title: Strings.PREFFERED, field: 'preferred', type: 'boolean' }
    ]
    return { teleCols }
}